import ApiService from '@/services/api.service';

const UsersService = {
    getAll(parameter) {
        var param = {
            SearchCriteria: parameter.SearchCriteria,
            PageSize: parameter.PageSize,
            PageNumber: parameter.PageNumber,
            RoleCode: parameter.RoleCode,
            CheckEmployeeDoctor: parameter.CheckEmployeeDoctor
        };
        if (parameter.Status != 'All') {
            param.Active = parameter.Status;
        }
        if (parameter.PasswordStatus != 'All') {
            param.PasswordStatus = parameter.PasswordStatus;
        }

        const requestData = {
            method: 'get',
            url: '/Users/',
            headers: {},
            params: param
        };
        return ApiService.customRequest(requestData);
    },

    get(id) {
        return ApiService.get(`/Users/${id}`);
    },

    getRols() {
        return ApiService.get('/UserRoleHeaders');
    },

    delete(id) {
        return ApiService.delete(`/Users/${id}`);
    },

    add(data) {
        return ApiService.post(`/Users`, data);
    },

    update(id, data) {
        return ApiService.put(`/Users/${id}`, data);
    },

    getUserByCode(id) {
        //return ApiService.get(`/Users/${id}`);
        const requestData = {
            method: 'get',
            url: '/Users/',
            headers: {},
            params: {
                Code: id
            }
        };
        return ApiService.customRequest(requestData);
    }
};

export default UsersService;
